import React, { ReactNode } from 'react';
import { store } from 'react-notifications-component';
import { Platform, usePlatform } from 'utils/hooks/usePlatform';

import Icon, { IconEnum } from 'components/common/Icon';

export const activeNotification = (title: string, message: ReactNode, type: 'danger' | 'success' | 'warning' | 'info' | 'default' | undefined, duration = 3000) => {
    const platform = usePlatform();
    let notificationMessage = message;

    switch (type) {
    case 'danger':
        notificationMessage = <div className="notification-message"><Icon icon={IconEnum.INFO_WHITE}/>{message}</div>;

        break;
    case 'success':
        notificationMessage = <div className="notification-message"><Icon icon={IconEnum.DANGER}/>{message}</div>;

        break;
    case 'warning':
        notificationMessage = <div className="notification-message"><Icon icon={IconEnum.APPROVE_WHITE}/>{message}</div>;

        break;
    default:
        break;
    }

    const isMobile = platform === Platform.IOS || platform === Platform.Android;

    store.addNotification({
        title,
        message: notificationMessage,
        type,
        width: isMobile ? 350 : 400,
        insert: isMobile ? 'bottom' : 'top',
        container: isMobile ? 'bottom-center' : 'bottom-right',
        animationIn: ['animated', 'fadeIn'],
        animationOut: isMobile ? [] : ['animated', 'fadeOut'],
        dismiss: {
            duration,
            onScreen: !isMobile,
            pauseOnHover: true
        }
    });
};
